import { OmitProperties } from 'ts-essentials';

export function omitNullValues<
  TKey extends string,
  TValue,
  TObject extends Record<TKey, TValue>,
>(object: TObject): OmitProperties<TObject, null> {
  const clonedObj = { ...object };

  for (const key in clonedObj) {
    if (Object.prototype.hasOwnProperty.call(clonedObj, key)) {
      if (clonedObj[key] === null) {
        delete clonedObj[key];
      }
    }
  }

  return clonedObj;
}
